<template>
  <Drawer
    class="drawer_modal"
    width="700"
    v-model="showDrawer"
  >
    <!-- CASH DETAIL -->
    <cashDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></cashDetail>

    <!-- CASH EDIT/CREATE FORM -->
    <cashForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></cashForm>
  </Drawer>
</template>

<script>
import {BaseItemData} from "../../base/base_item.js";

import cashForm from "@/apps/cash/cashForm.vue";
import cashDetail from "@/apps/cash/cashDetail.vue";

let _app = BaseItemData();
_app.components = {
  cashForm,
  cashDetail
};
_app.data = function () {
  return {
    titles: {
      detail: "Касса",
      edit: "Редактирование кассы",
      create: "Создание кассы"
    },
    itemAction: "detail",
    itemId: "",
    showDrawer: false
  };
};
export default _app;
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/cash/cashItem.vue